import { defaultQueueMetricsParams } from '@/utils/metricsParams';
import { MetricsSection } from './MetricsSection';
import { api } from '@/store/api';
import { ADHERENCE_GROUPINGS } from '@/types/agentEvents';

const { useGetAverageQueueAnswerTimeMetricsQuery } = api;

export function AverageQueueAnswerTimeSection() {
  return (
    <MetricsSection
      titleKey="components.dashboard.averageQueueAnswerTime"
      descriptionKey="components.dashboard.averageQueueAnswerTimeDescription"
      metricName="average-queue-answer-time"
      defaultParams={defaultQueueMetricsParams()}
      useQuery={useGetAverageQueueAnswerTimeMetricsQuery}
      groupingsOptions={ADHERENCE_GROUPINGS}
      refreshLabelKey="components.dashboard.refreshAverageQueueAnswerTime"
    />
  );
}
